import { useAtomValue, useSetAtom } from "jotai";
import Script from "next/script";
import { type FunctionComponent, useCallback } from "react";

import { googleFundingChoicesAtom } from "~/components/advertisement/funding-choices/atoms";
import { config } from "~/data";

import { magnitePrebidJSAtom } from "./atoms";

export const MagniteDemandManagerScripts: FunctionComponent = () => {
  const setMagnitePrebidJSAtom = useSetAtom(magnitePrebidJSAtom);
  const { isReady: isFundingChoiceReady } = useAtomValue(googleFundingChoicesAtom);

  const handleLoaded = useCallback(() => {
    setMagnitePrebidJSAtom({
      isReady: true,
    });
  }, [setMagnitePrebidJSAtom]);

  if (!isFundingChoiceReady) return null;

  return (
    <Script
      id="magnite-demand-manager-script"
      src={config.advertisement.magniteDemandManger.scriptUrl}
      strategy="lazyOnload"
      onError={handleLoaded}
      onLoad={handleLoaded}
    />
  );
};

MagniteDemandManagerScripts.displayName = "MagniteDemandManagerScripts";
